import { getCookie } from '@/helpers/cookies'

const CSRF_COOKIE = 'CSRF-TOKEN'
const CSRF_HEADER = 'X-CSRF-Token'

export function getCSRFTokenCookie() {
  const token = getCookie(CSRF_COOKIE)
  return token
}

export function setCSRFTokenHeader(headers, token) {
  headers[CSRF_HEADER] = token
}
